function TenantLogsCtrl($stateParams,
                        TenantsService,
                        $state,
                        ProgressBarService,
                        IntegrationEvents,
                        $scope,
                        DateManipulationService) {
  "ngInject";

  let vm = this;
  $scope.tabIndex = 5;
  vm.tenantId = $stateParams.tenantId;
  let tenantPromise = TenantsService.getTenantById(vm.tenantId);
  tenantPromise.then(data => {
    vm.currentTenant = data
  });

  vm.localFromUtc = function (events) {
    for (let i = 0; i < events.length; i++) {
      let each = events[i];
      if (each.utcTimestamp) {
        each.utcTimestamp = DateManipulationService.utcFormattedString(each.utcTimestamp);
      }
    }
    return;
  };

  vm.getTenantCreateEvents = function () {
    ProgressBarService.start();
    let enrollmentEventsPromise = IntegrationEvents.getTenantCreateEvents(vm.tenantId);
    enrollmentEventsPromise.then(function (data) {
      vm.tenantCreateEvents = data;
      vm.localFromUtc(data);
      ProgressBarService.complete();
    });
  };


  //////////////////////////////////////////////////////////////
  // Setup
  //////////////////////////////////////////////////////////////

  vm.initialize = () => {
    vm.getTenantCreateEvents()
  }

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  return vm;
}

export {TenantLogsCtrl}
